import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { EX5225 } from 'config/flags';
import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'rsuite';
import { COUNTRY } from 'utils/country';
import { useUser } from 'utils/hooks';
import useStyles from './DatePicker.styles';
const DatePickerForm = ({ onClean, onChange, defaultValue = null, placement, isExpired }) => {
    //translate by country
    const { t } = useTranslation();
    const { userLocaleCountryCode } = useUser({});
    const classes = useStyles();
    const parentRef = useRef(null);
    const parentContainer = useCallback(() => parentRef.current, []);

    const formatDatePicker = EX5225 && userLocaleCountryCode === COUNTRY.US ? 'MM/dd/yyyy' : 'dd/MM/yyyy';

    const LOCALE = {
        sunday: EX5225 ? t('calendarDatePicker.sun') : 'Dom',
        monday: EX5225 ? t('calendarDatePicker.mon') : 'Lun',
        tuesday: EX5225 ? t('calendarDatePicker.tue') : 'Mar',
        wednesday: EX5225 ? t('calendarDatePicker.wed') : 'Mié',
        thursday: EX5225 ? t('calendarDatePicker.thu') : 'Jue',
        friday: EX5225 ? t('calendarDatePicker.fri') : 'Vie',
        saturday: EX5225 ? t('calendarDatePicker.sat') : 'Sáb',
        ok: EX5225 ? t('calendarDatePicker.buttonApply') : 'Aplicar',
        formattedMonthPattern: EX5225 ? t('calendarDatePicker.formatDate') : 'MMMM yyyy',
    };

    const isValidDate = (dateObject) => new Date(dateObject).toString() !== 'Invalid Date';

    const date: Date | null = isValidDate(defaultValue) ? new Date(defaultValue) : null;

    const formatDateRequest = (created_at) => {
        if (!!created_at) {
            const dateObj = new Date(created_at.setHours(0, 0, 0, 0));
            let day: string | number = dateObj.getDate();
            let month: string | number = dateObj.getMonth() + 1;
            let year: string | number = dateObj.getFullYear();

            if (day < 10) day = '0' + day;
            if (month < 10) month = '0' + month;

            return `${year}-${month}-${day}`;
        } else {
            return null;
        }
    };

    return (
        <div ref={parentRef} className={classes.wrapperContainer}>
            {!!isValidDate(defaultValue) ? (
                <DatePicker
                    container={parentContainer}
                    defaultValue={date}
                    // @ts-ignore
                    caretAs={() => ''}
                    placeholder={t('settings.commercialAgreements.sett_buttonComercialAgreementsVigency') || 'Vigencia'}
                    format={formatDatePicker}
                    locale={LOCALE}
                    type="date"
                    shouldDisableDate={(date) => date < new Date()}
                    className={[classes.DatePickerRoot, !!isExpired && classes.expires_at].join(' ')}
                    onClean={(e) => onClean()}
                    menuClassName={classes.menuCustom}
                    onChange={(e) => {
                        onChange(e);
                    }}
                    onKeyDown={(e) => {
                        e.preventDefault();
                    }}
                    onOk={(date: Date, event) => {
                        if (formatDateRequest(date) === formatDateRequest(new Date())) {
                            event.preventDefault();
                        }
                    }}
                    placement={placement}
                />
            ) : (
                <DatePicker
                    container={parentContainer}
                    // @ts-ignore
                    caretAs={() => ''}
                    placeholder={t('settings.commercialAgreements.sett_buttonComercialAgreementsVigency') || 'Vigencia'}
                    format={'dd/MM/yyyy'}
                    locale={LOCALE}
                    type="date"
                    shouldDisableDate={(date) => date < new Date()}
                    className={[classes.DatePickerRoot, !!isExpired && classes.expires_at].join(' ')}
                    onClean={(e) => onClean()}
                    menuClassName={classes.menuCustom}
                    onChange={(e) => {
                        onChange(e);
                    }}
                    onKeyDown={(e) => {
                        e.preventDefault();
                    }}
                    onOk={(date: Date, event) => {
                        if (formatDateRequest(date) === formatDateRequest(new Date())) {
                            event.preventDefault();
                        }
                    }}
                    placement={placement}
                />
            )}
            <div className={classes.containerIcon}> {<CalendarTodayIcon className={classes.icon} />} </div>
        </div>
    );
};

export default DatePickerForm;
